import { useTranslation } from "react-i18next";
import type { BuilderDayLayout } from "../../lib/metadata-builder/day-layouts";
import { dayLayoutException } from "../../lib/metadata-builder/day-layouts";
import type { ArtMetadata } from "../../lib/schedule-presets/art-metadata";
import type { MetadataDay } from "../../lib/metadata-history/metadata-targets";
import { dispatchBuilderMetadata } from "../../lib/metadata-builder/edit-text";
import { endMetadataMerge } from "../../lib/metadata-history/dispatch";
import { Button } from "../ui/button";

type DayLayoutExceptionControlsProps = { metadata: ArtMetadata; layout: BuilderDayLayout; day: MetadataDay };

export function DayLayoutExceptionControls({ metadata, layout, day }: DayLayoutExceptionControlsProps) {
  const { t } = useTranslation();
  const custom = !!layout.exceptions[day];
  const setCustom = (enabled: boolean) => {
    endMetadataMerge();
    const updated = dayLayoutException(metadata, layout, day, enabled);
    dispatchBuilderMetadata({ type: "day-layout/set", ...updated, day, action: enabled ? "exception" : "shared" });
  };
  return (
    <div className="space-y-1.5 rounded border border-neutral-200 p-2">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <label className="flex items-center gap-2">
          <input type="checkbox" checked={custom} onChange={event => setCustom(event.target.checked)} />
          {t("builder.offline.customDay")}
        </label>
        {custom && <Button size="sm" variant="outline" onClick={() => setCustom(false)}>{t("builder.offline.returnShared")}</Button>}
      </div>
      <p className="text-neutral-500">{custom ? t("builder.offline.customHelp") : t("builder.days.sharedHelp")}</p>
    </div>
  );
}
